var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTier4Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8049 0.285524C10.1112 0.108824 10.4884 0.108824 10.7947 0.285524L20.1042 5.65635C20.4107 5.83322 20.5996 6.16026 20.5996 6.51419V17.2546C20.5996 17.6085 20.4107 17.9356 20.1042 18.1124L10.7947 23.4833C10.4884 23.66 10.1112 23.66 9.8049 23.4833L0.495458 18.1124C0.188883 17.9356 0 17.6085 0 17.2546V6.51419C0 6.16026 0.188883 5.83322 0.495458 5.65635L9.8049 0.285524Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "changeBg",
    d: "M10.0518 4.34198C10.2049 4.25363 10.3935 4.25363 10.5467 4.34198L16.7119 7.89886C16.8652 7.9873 16.9597 8.15081 16.9597 8.32778V15.4409C16.9597 15.6179 16.8652 15.7814 16.7119 15.8698L10.5467 19.4267C10.3935 19.5151 10.2049 19.5151 10.0518 19.4267L3.8865 15.8698C3.73321 15.7814 3.63877 15.6179 3.63877 15.4409V8.32778C3.63877 8.15081 3.73321 7.9873 3.8865 7.89886L10.0518 4.34198Z",
    strokeWidth: 0.495183
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "changeStroke",
    d: "M18.4414 11.25L18.4414 15.4486",
    stroke: "",
    strokeWidth: 0.495183,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "changeStroke",
    d: "M2.26953 8.32812V10.4168",
    stroke: "",
    strokeWidth: 0.495183,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "changeFill",
    d: "M10.4288 7.59438C10.3965 7.45856 10.2033 7.45856 10.171 7.59438L9.13711 11.9466C9.13375 11.9607 9.12808 11.9742 9.12033 11.9865L7.21545 15.0123C7.14245 15.1283 7.27196 15.2652 7.3918 15.1988L10.2357 13.6224C10.2756 13.6003 10.3242 13.6003 10.3641 13.6224L13.208 15.1988C13.3278 15.2652 13.4573 15.1283 13.3843 15.0123L11.4795 11.9865C11.4717 11.9742 11.466 11.9607 11.4627 11.9466L10.4288 7.59438Z",
    fill: ""
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTier4Icon);
export default __webpack_public_path__ + "static/media/tier-4-icon.9ccf06f5e7928e2cd6a9baa551c26192.svg";
export { ForwardRef as ReactComponent };